import { Droplet, Stethoscope, Activity, HeartPulse, ShieldCheck, Thermometer } from "lucide-react";

export const CLINIC = {
  name: "Dr. Saurabh Agarwal Clinic",
  doctor: "Dr. Saurabh Agarwal",
  title: "Consultant Physician & Diabetologist",
  city: "Lucknow",
  phone: "7355390282",
  whatsapp: "7309434794",
  email: "drsaurabh.aga@gmail.com",
  qualifications: ["MBBS", "MD (KMC Manipal)", "FAGE", "FIDM (UK)", "CCID (UK)", "CCEBDM"],
  experience: [
    "Ex – Indraprastha Apollo Hospital, New Delhi",
    "Ex – Fortis C-DOC Hospital, New Delhi",
    "Ex – Nanavati Max Hospital, Mumbai",
  ],
};

export const whatsappLink = (text) => `https://wa.me/91${CLINIC.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const whatsappAppLink = (text) => `whatsapp://send?phone=91${CLINIC.whatsapp}&text=${encodeURIComponent(text)}`;

export const SERVICES = [
  { icon: Droplet, title: "Diabetes Care", text: "Type 1, Type 2 and gestational diabetes — sugar monitoring, HbA1c tracking, medication and insulin planning.", featured: true },
  { icon: Stethoscope, title: "General Medicine", text: "Fever, infections, acidity, fatigue and everyday adult medical concerns." },
  { icon: Thermometer, title: "Thyroid Disorders", text: "Diagnosis and long-term management of hypo- and hyperthyroidism." },
  { icon: Activity, title: "Hypertension", text: "Blood pressure assessment, treatment and lifestyle guidance." },
  { icon: HeartPulse, title: "Heart Risk Assessment", text: "Cholesterol, lipid profile review and cardiovascular risk reduction." },
  { icon: ShieldCheck, title: "Preventive Health Checks", text: "Routine screening and follow-ups to catch problems early." },
];

export const FAQS = [
  { q: "Where can I see Dr. Agarwal?", a: "At Health City Vistaar (Vasant Khand), Dhawan Medical Center (Indiranagar) and Swasthyam Medical Clinic (Indiranagar), or through an online video consultation. Pick your preferred option while booking." },
  { q: "Is online consultation available?", a: "Yes. Online consultations are available Monday to Sunday, 9:00 AM – 9:00 PM. Choose 'Online' as the appointment type when booking." },
  { q: "Is there any discount for women?", a: "Women get 30% off consultation fees every Sunday." },
  { q: "What should I bring to my first visit?", a: "Please bring previous prescriptions, recent blood reports (sugar, HbA1c, thyroid, lipid profile) and a list of medicines you currently take." },
  { q: "How do I reschedule or cancel?", a: "Call +91 7355390282 or message us on WhatsApp at +91 7309434794 with your booking reference and we will help you change the appointment." },
];
